;(function( window, document, $, undefined ) {
	'use strict';

	// Menu

	function menu() {

    // Insert btn menu
    function insertBtnMainMenu() {
      var btnToggleMenu = '<button class="btn-menu" type="button" data-js="btnMainMenu"><span class="icon"></span><span class="label">Menu</span></button>';
      $('.site-header').find('.wrap').eq(0).prepend( btnToggleMenu );
    }

    // Btn menu toggle
    function btnMenuToggle() {
      $('body').on('click', '.btn-menu', function(e){
        e.preventDefault();
        var $this = $('.btn-menu');
        var $target = $('.nav-primary');
        if( $this.hasClass('-active') ) {
          $this.removeClass('-active');
          $target.slideUp(500, function(){
            $target.removeClass('-active');
          });
        } else {
          $this.addClass('-active');
          $target.slideDown(500, function(){
            $target.addClass('-active');
          });
        }
      });
    }

    // Submenu Effect
    function submenuEffect() {

      // Add Submenu Container
      $('.site-header > .wrap').append( '<div class="full-submenu"><div class="full-submenu-content"><div class="wrap"></div></div></div>' );

      // Function Reset Menu
      function resetSubmenu() {
        $('.full-submenu').hide();
        $('.menu-primary .menu-item a').removeClass('active');
        $('body').removeClass('no-scroll');
      }

      // Menu active
      $('.menu-item > a').mouseenter(function() {

        var $this = $(this);
        var $container = $('.full-submenu');
        var $target = $container.find('.wrap');
        var clone = $this.siblings('.sub-menu').clone();

        // Link active
        $('.menu-primary > .menu-item:not(.menu-item-has-fullSubmenu):not(.highlight) > a').removeClass('active');

        // If has submenu
        if( $this.closest('.menu-item:not(.menu-item-has-fullSubmenu):not(.highlight)').hasClass('menu-item-has-children') ) {

          $('.menu-item-has-fullSubmenu a').removeClass('active');
          $('.full-submenu').removeClass('full-submenu-click');

          $this.addClass('active');
          $container.show().css('opacity', '0');
          $('body').addClass('no-scroll');

          $target.empty().append( clone );
          $('.full-submenu').find('.sub-menu').show();

          $container.css('opacity', '1');

        } else {
          if( $('.full-submenu-click').length < 1 ) {
            $container.fadeOut(100, function() {
              $container.css('opacity', '0').hide();
            });
          }
        }

      });

      // Mouse Leave
      $('.full-submenu .wrap').mouseleave(function(){
        setTimeout(function(){
          if( $('.menu-item-has-children:hover').length < 1 && $('.full-submenu-click').length < 1 ) {
            resetSubmenu();
          }
        }, 100);
      });
      $('.menu-primary .menu-item-has-children:not(.menu-item-has-fullSubmenu):not(.highlight)').mouseleave(function(){
        setTimeout(function(){
          if( $('.menu-item-has-children:not(.menu-item-has-fullSubmenu):not(.highlight):hover').length < 1 && $('.full-submenu .wrap:hover').length < 1 ) {
            resetSubmenu();
          }
        }, 100);
      });

      // Menu hamburguer
      $('.menu-item-has-fullSubmenu > a').click(function(e){
        e.preventDefault();

        var $this = $(this);
        var $container = $('.full-submenu');
        var $target = $container.find('.wrap');
        var clone = $this.siblings('.sub-menu').clone();
        var $body = $('body');
        var titleMenuItem = $this.text();
        var titleMenuLink = $this.attr('href');

        if( !($this.hasClass('active')) ) {

          $this.addClass('active');
          $container.show().css('opacity', '0');
          $container.addClass('full-submenu-click');
          $body.addClass('no-scroll');

          $target.empty().append( clone );
          $('.full-submenu').find('.sub-menu').prepend('<li class="menu-item menu-item-title"><a href="' + titleMenuLink + '">' + titleMenuItem + '</a></li>');
          $('.full-submenu').find('.sub-menu').show();
          $container.css('opacity', '1');

        } else {
          $this.removeClass('active');
          $container.fadeOut(100, function() {
            $container.css('opacity', '0').hide();
            $container.removeClass('full-submenu-click');
            $body.removeClass('no-scroll');
          });
        }
      });

    }

    // Add Contact Infos in Menu
    function menuContact() {
      var contactClone = $('.utility-bar ul').clone();
      $('.menu-primary').append('<div class="menu-contact"></div>');
      $('.menu-contact').append( contactClone );
    }

		// Globals
		return {
      insertBtnMainMenu : insertBtnMainMenu,
      btnMenuToggle : btnMenuToggle,
      submenuEffect: submenuEffect,
      menuContact: menuContact
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.menu = menu();

})( window, document, jQuery );
